import { defineStore } from "pinia";
import { ref } from "vue";
import UserRepository from "@/infraestructure/api/user";

const userRepository = new UserRepository();

export const useAuthStore = defineStore('auth', () => {
    const user = ref(null);

    const loadUser = () => {
        const saved = localStorage.getItem('user');
        if (saved) {
            user.value = JSON.parse(saved);
        }
    }

    const setUser = (userData) => {
        user.value = userData;
        localStorage.setItem('user', JSON.stringify(userData));
    }

    const login = async (login, password) => {
        try {
            const response = await userRepository.getUser(login, password);
            if (!response) return false;

            setUser(response);
            return true;
        } catch (error) {
            console.log(error)
            return false;
        }
    }

    const logout = () => {
        user.value = null;
        localStorage.removeItem('user');
    }

    return { user, login, logout, loadUser }
})